/*
 * File: OrderCardDetails.js
 * Project: mp-mobile-app
 *
 * Created by Rob Rothe
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays the details in the list of orders
 */
import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import OrderStatusReporter from "./OrderStatusReporter";
import { withStyles } from "@material-ui/core/styles";
import { StoreContext } from "utils/useStore";

const styles = theme => ({
  root: {
    paddingTop: 0,
    paddingBottom: 0
  },
  orderDetails: {
    color: theme.palette.common.black
  }
});

const OrderCardDetails = ({ order, classes }) => {
  const storeManager = useContext(StoreContext);
  const typeString = order.typeString(storeManager);
  const {
    patientName,
    providerName,
    due,
    assignedToName
  } = order;

  return (
    <div className={classes.root}>
      <div className={classes.orderDetails}>
        <OrderStatusReporter order={order} />
        <br />
        {patientName && (
          <Typography variant="body1">
            <b>Patient: </b>
            {patientName}
            <br />
          </Typography>
        )}
        {providerName && (
          <Typography variant="body1">
            <b>Provider: </b>
            {providerName}
            <br />
          </Typography>
        )}
        {typeString && (
          <Typography variant="body1">
            <b>Type: </b>
            {typeString}
            <br />
          </Typography>
        )}
        {due && (
          <Typography variant="body1">
            <b>Due: </b>
            {order.dueDate}
            <br />
          </Typography>
        )}
        {assignedToName && (
          <Typography variant="body1">
            <b>Assigned: </b>
            {assignedToName}
          </Typography>
        )}
      </div>
    </div>
  );
};

OrderCardDetails.propTypes = {
  order: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(OrderCardDetails);
